import React, { useState } from 'react'
import { FormatRupiah } from '../services/FormatRupiah';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from 'react-hook-form';

const FormPengiriman = ({ kurir, ongkir, setOngkir, cartTotal, nextStep }) => {
    const [selected, setSelected] = useState(null);

    const formSchema = Yup.object().shape({
        kurir: Yup.string().required("Pilih salah satu kurir"),
    });

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        mode: "onTouched",
        resolver: yupResolver(formSchema),
    });

    const handleSelect = (e, idx) => {
        setSelected(idx);
        setValue('kurir', String(idx), { shouldValidate: true });
        const selectedKurir = kurir[idx];
        const total = parseInt(selectedKurir?.price) + cartTotal;
        setOngkir({
            ...ongkir,
            ongkir: selectedKurir?.price,
            total,
            courier_code: selectedKurir?.courier_code,
            courier_type: selectedKurir?.type,
        });
    };

    const onSubmit = () => nextStep();

    /* ── Courier logo helper ── */
    const courierIcon = (code = '') => {
        const map = {
            jne: '📦', jnt: '🚚', grab: '🟢', gojek: '🔵',
            sicepat: '⚡', anteraja: '🟠',
        };
        return map[code.toLowerCase()] ?? '📫';
    };

    return (
        <div className="co-card">
            <div className="co-card-header">
                <div className="co-card-icon">
                    <i className="bi bi-truck" />
                </div>
                <div>
                    <h4 className="co-card-title">Pilih Pengiriman</h4>
                    <p className="co-card-desc">Pilih kurir dan layanan yang sesuai untukmu</p>
                </div>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="co-form">
                {/* Hidden field for validation */}
                <input type="hidden" {...register('kurir')} />

                {kurir.length === 0 ? (
                    <div className="co-kurir-empty">
                        <i className="bi bi-exclamation-circle" />
                        <p>Tidak ada layanan pengiriman tersedia untuk alamat ini.</p>
                    </div>
                ) : (
                    <div className="co-kurir-list">
                        {kurir.map((kr, i) => (
                            <label
                                key={i}
                                className={`co-kurir-card ${selected === i ? 'selected' : ''}`}
                                onClick={(e) => handleSelect(e, i)}
                            >
                                <div className="co-kurir-left">
                                    <span className="co-kurir-emoji">{courierIcon(kr.courier_code)}</span>
                                    <div className="co-kurir-info">
                                        <span className="co-kurir-name">
                                            {kr.courier_name}
                                            <span className="co-kurir-type ms-2">{kr.courier_service_name}</span>
                                        </span>
                                        <span className="co-kurir-eta">
                                            <i className="bi bi-clock me-1" />
                                            Estimasi {kr.shipment_duration_range} {kr.shipment_duration_unit}
                                        </span>
                                        {kr.description && (
                                            <span className="co-kurir-desc">{kr.description}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="co-kurir-right">
                                    <span className="co-kurir-price">{FormatRupiah(kr.price)}</span>
                                    <div className={`co-kurir-radio ${selected === i ? 'checked' : ''}`}>
                                        {selected === i && <i className="bi bi-check-lg" />}
                                    </div>
                                </div>
                            </label>
                        ))}
                    </div>
                )}

                {errors.kurir && (
                    <span className="co-error mt-2 d-block">{errors.kurir.message}</span>
                )}

                <div className="co-form-footer">
                    <button type="submit" className="co-btn-primary">
                        <span>Konfirmasi Pengiriman</span>
                        <i className="bi bi-arrow-right ms-2" />
                    </button>
                </div>
            </form>
        </div>
    );
};

export default FormPengiriman;